import { Box, Card, CardContent, Typography, Divider, Stack, Grid, Paper, Container, IconButton } from "@mui/material";
import errorHandler from "../../utils/errorHandler";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { fDate } from "../../utils/formatTime";
import { capitalizeFirstLetter } from "../../utils/helpers";
import { gameManagementApi } from "../../services/AllServices";

const ViewGameManagement = () => {
    const { id } = useParams();
    const [data, setData] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await gameManagementApi.getById({ id });
                setData(response?.data?.data);
            } catch (error) {
                errorHandler(error);
            }
        };

        fetchData();
    }, [id]);

    return (
        <Container maxWidth="md">
            <Paper elevation={6} sx={{ borderRadius: 3, overflow: "hidden", p: 4, mt: 5 }}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBack />
                </IconButton>

                <Stack spacing={3}>
                    <Typography variant="h4" fontWeight="bold" textAlign="center">
                        Game Title: {data?.title || "Game Details"}
                    </Typography>

                    <Typography variant="subtitle1" textAlign="center">
                        {data?.description}
                    </Typography>

                    <Divider />

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography fontWeight="bold">Game Type:</Typography>
                            <Typography>{capitalizeFirstLetter(data?.type)}</Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography fontWeight="bold">Status:</Typography>
                            <Typography>{data?.status === 1 ? "Active" : "Inactive"}</Typography>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Typography variant="h6" fontWeight="bold">Rules</Typography>
                    {data?.rules?.length > 0 ? (
                        data.rules.map((rule, index) => (
                            <Box key={index} sx={{ border: '1px solid #ccc', p: 2, borderRadius: 2, mb: 2 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography fontWeight="bold">Rule Type:</Typography>
                                        <Typography>{capitalizeFirstLetter(rule.ruleType)}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography fontWeight="bold">Scoring Type:</Typography>
                                        <Typography>{capitalizeFirstLetter(rule.scoringType)}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography fontWeight="bold">Max Players:</Typography>
                                        <Typography>{rule?.ruleType === "action" || rule?.ruleType === "position" ? "5" : rule.maxPlayers}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography fontWeight="bold">Squad Size:</Typography>
                                        <Typography>
                                            {
                                                rule?.ruleType === "action" || rule?.ruleType === "position" ? "5" :
                                                    rule.squadSize
                                            }
                                        </Typography>
                                    </Grid>

                                    {rule?.ruleType === "action" || rule?.ruleType === "position" ? null :
                                        <Grid item xs={6}>
                                            <Typography fontWeight="bold">Bench Players:</Typography>
                                            <Typography>{rule.benchPlayers}</Typography>
                                        </Grid>
                                    }

                                    <Grid item xs={6}>
                                        <Typography fontWeight="bold">Budget:</Typography>
                                        <Typography>
                                            {rule.isBudgetUnlimited ? "Unlimited" : `£${rule.budgetLimit}`}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <Divider sx={{ my: 2 }} />
                                <Stack spacing={2} mt={1}>
                                    {rule.allowedPositions?.length > 0 ? (
                                        <>
                                            <Typography variant="subtitle1" fontWeight="bold">Allowed Positions & Actions:</Typography>
                                            <Stack spacing={2} mt={1}>
                                                {rule.allowedPositions.map((position) => (
                                                    <Box key={position._id} sx={{ pl: 2 }}>
                                                        <Typography fontWeight="bold">{position.title}</Typography>
                                                        <ul style={{ marginTop: 4 }}>
                                                            {position.allowedAction?.map((action) => (
                                                                <li key={action._id}>
                                                                    {action.title} {action.isAllowed ? "(Allowed)" : "(Not Allowed)"}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </Box>
                                                ))}
                                            </Stack>
                                        </>
                                    ) : rule.allowedPoints?.length > 0 ? (
                                        <>
                                            <Typography variant="subtitle1" fontWeight="bold">Allowed Points:</Typography>
                                            <ul>
                                                {rule.allowedPoints.map((point) => (
                                                    <li key={point._id}>
                                                        {point.title} {point.isAllowed ? "(Allowed)" : "(Not Allowed)"}
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        <Typography></Typography>
                                    )}

                                </Stack>
                            </Box>
                        ))
                    ) : (
                        <Typography>No rules defined.</Typography>
                    )}
                </Stack>
            </Paper>
        </Container>

    );
};

export default ViewGameManagement;
